import { useQuery } from "@tanstack/react-query"

import { useMessagingContext } from "../providers/MessagingProvider"

export const useChannel = (channelId?: string) => {
  const { client } = useMessagingContext()
  const { data, ...rest } = useQuery(
    ["channel", channelId],
    async () => {
      const channel = client.channel("messaging", channelId)
      await channel.watch()
      return channel
    },
    {
      enabled: !!channelId,
      refetchOnWindowFocus: false,
    },
  )

  return {
    ...rest,
    channel: data,
  }
}
